
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import PageFooter from '@/components/page-footer.vue';
	import {
		getAnnouncementDetail,
		createAnnouncement
	} from '@/api/material';

	@Component({
		name: 'notice-detail',
		components: {
			PageFooter
		}
	})
	export default class NoticeDetail extends Vue {
		private type = this.$route.query.type;
		private id = this.$route.query.id;

		private formData: any = {
			Id: 0,
			Title: '',
			Content: '',
			SendTime: '',
			IsSendNow: true
		}
		private formRule: any = {
			'name': '请输入公告标题',
			'content': '请输入公告内容',
		}

		mounted() {
			if (this.type === 'edit') {
				this.getDetail()
			}
		}

		private isEmpty() {
			for (let key in this.formData) {
				if (!this.formData.IsSendNow && !this.formData.SendTime) {
					this.$message({
						type: 'warning',
						message: '请选择发送时间'
					})
					return true;
				}
				if (this.formRule[key] && !this.formData[key]) {
					this.$message({
						type: 'warning',
						message: this.formRule[key]
					})
					return true
				}
			}
			return false;
		}

		private async getDetail() {
			try {
				const res: any = await getAnnouncementDetail({
					Id: +this.id
				})
				this.formData = res.Result;
			} catch (err) {
				console.log(err)
			}
		}

		private submit() {
			if (this.isEmpty()) return
			if (this.formData.SendTime && !this.formData.IsSendNow) {
				
			} else {
				this.formData.SendTime = 0;
			}
	
			this.doUpdate()
		}

		private async doUpdate() {
			try {
				await createAnnouncement(this.formData)
				this.$message({
					type: 'success',
					message: '编辑成功'
				})
				this.toBack()
			} catch (e) {
				console.log(e)
			}
		}

		private toBack() {
			this.$router.go(-1);
		}
	}
